import '../css/style.scss'
import {UIManager} from './ui_html/UIManager.ts'
import {EntryShared, socket, uiGameManager} from '../../shared/scripts/EntryShared.ts'
import {SocketWebActionController} from './SocketActionController.ts'
import {EntryHomepageUrlParameterController} from './EntryHomepageUrlParameterController.ts'
import {UIWNotificationController} from './notifications/UIWNotificationController.ts'
import {UIWGameManager} from './ui_game/UIWGameManager.ts'
import {UIWGeneralServicesController} from './UIWGeneralServicesController.ts'
import {Scene} from './ui_html/UISceneTypes.ts'
import {registerWebRoomClientHandlers} from './WebRoomClientHandlers.ts'
import {registerSharedRoomClientHandlers} from '../../shared/scripts/SharedRoomClientHandlers.ts'

export let uiManager: UIManager

export class EntryHomepage extends EntryShared {
    protected socketActionController: SocketWebActionController

    async initialize() {
        await this.initializeSoundAndVersionController()

        await EntryShared.initializeEntry()
        this.webGLCheck()

        uiManager = new UIManager()
        this.initializeUIManagerEvents(uiManager.uiManagerEvents)

        this.initializeGameManager(new UIWGameManager(uiManager.adController))
        EntryShared.initializeNotification(new UIWNotificationController())

        const generalServicesController = new UIWGeneralServicesController(uiManager, uiManager.header)
        this.socketActionController = this.createSocketActionController(generalServicesController)
        EntryShared.initializeSocket(this.socketActionController, () => uiManager.sceneController.scene == Scene.Game)

        registerSharedRoomClientHandlers(socket.roomClient)
        registerWebRoomClientHandlers(socket.roomClient, uiManager)

        uiManager.init()
        generalServicesController.init()

        socket.connect()

        await EntryHomepageUrlParameterController.loadParameterEvents()
        await this.completeInitialization()
    }

    // eslint-disable-next-line class-methods-use-this
    protected createSocketActionController(generalServicesController: UIWGeneralServicesController): SocketWebActionController {
        return new SocketWebActionController(uiGameManager, uiManager, generalServicesController)
    }
}
